import React from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../shared/dialog/dialogHeader';
import useDialog from '../shared/dialog/useDialog';
import DialogSection from '../shared/dialog/dialogSection';

const HelloWorldDialog: React.FC = () => {
  const {setDialog} = useDialog();
  return (
    <KFLDialog
      header={
        <DialogHeader
          title={'Hello World'}
          fnCloseDialog={() => setDialog?.()}
        />
      }
      sections={[<DialogSection>How is the virus going?</DialogSection>]}
    />
  );
};

export default HelloWorldDialog;
